import React from 'react';
import { Link } from 'react-router-dom';

const About: React.FC = () => {
  return (
    <div className="container-fluid about py-5">
      <div className="container py-5">
        <div className="row g-5">
          <div className="col-lg-7 wow fadeInLeft" data-wow-delay="0.2s">
            <div className="h-100">
              <h4 className="text-primary">About Us</h4>
              <h1 className="display-4 mb-4">Trusted Partner in <strong style={{ color: "#ff5512" }}>Total Water and Wastewater Management</strong></h1>
              <div className="row g-4 mb-4">
                <div className="col-md-6">
                  <Link to="/about" className="d-flex">
                    <span className="fas fa-hand-holding-water fa-3x me-3"></span>
                    <h4 className="mb-0">Customized Water Solutions</h4>
                  </Link>
                </div>
                <div className="col-md-6">
                  <Link to="/about" className="d-flex">
                    <span className="fas fa-vote-yea fa-3x me-3"></span>
                    <h4 className="mb-0">Sustainable Innovation</h4>
                  </Link>
                </div>
              </div>
              <p className="mb-4">With over 25 years of experience, Wasser Technochem (I) Ltd. (WTIL) has grown into one of India's leading companies in industrial water and wastewater treatment. We are proud to be ISO 9001:2015 and ISO 45001:2018 certified and registered as an MSME enterprise, underscoring our commitment to quality, safety, and innovation.
WTIL holds the distinction of being Rajasthan's first water treatment company, established with the goal of addressing water challenges for industries in the region. We were also the first to introduce organized Operation & Maintenance (O&M) services for large textile houses and cement plants in the state — a pioneering move that continues to set us apart.
We specialize in end-to-end water treatment solutions, ranging from chemical supply and design consultancy to large-scale project execution and long-term service contracts. Our mission is to help industries in India optimize water usage, reduce environmental impact, and ensure long-term regulatory compliance.

              </p>
              <div className="text-dark mb-4">
                <p className="fs-5"><span className="fa fa-check text-primary me-2"></span> Customized Water
                  Solutions, Engineered for Efficiency..</p>
                <p className="fs-5"><span className="fa fa-check text-primary me-2"></span> 25 Years of Sustainable
                  Innovation in Water Treatment..</p>
                <p className="fs-5"><span className="fa fa-check text-primary me-2"></span> Transforming Water
                  Challenges into Smart, Scalable Solutions.</p>
              </div>

            </div>
          </div>
          <div className="col-lg-5 wow fadeInRight" data-wow-delay="0.2s">
            <div className="position-relative h-100">
              <img src="img/about-1.jpg" className="img-fluid w-100 h-100" style={{ objectFit: "contain" }} alt="" />
              <div className="bg-white">
                <div className="position-absolute pt-3 bg-white" style={{ width: "50%", left: "0", bottom: "0" }}>
                  <div className="bg-primary p-4">
                    <h4 className="display-2 mb-0">25+</h4>
                    <p className="text-white fs-5 mb-0">years of experience</p>
                  </div>
                </div>
                <div className="position-absolute p-3 bg-white pb-0 pe-0"
                  style={{ width: "50%", bottom: "0", right: "0" }}>
                  <img src="img/about-3.jpg" className="img-fluid" alt="" />
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
